import { type AxiosInstance } from "axios";

export const startImpersonation = async (axiosInstance: AxiosInstance, userId: number) => {
  return await axiosInstance.post(`/api/v1/user/users/${userId}/impersonate`);
};

export const endImpersonation = async (axiosInstance: AxiosInstance) => {
  return await axiosInstance.post(`api/v1/user/users/impersonation/logout`);
};
